import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CompanyInfoSii,
  Deptors,
  InfoCompany,
  FilterPagination,
  Operations,
  RequestDeptors,
  RequestInvoices,
  RequestMinutes,
  SummaryCompany,
  ResultsInvoice,
  DetailOperations,
  CompanyBuyInvoiceDTO,
  DebtsCompaniesAll,
  CompanyUserAssignment,
  CompanyMPSummary,
  ClientWarranty,
  InfoClient,
  MonthlyActivity,
  ResultsTopInvoices
} from '../interface/company-client.interface';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/enviroments';
import { CompanyRelations, InfoOwners, Owners } from '../interface/owners.interface';
import { FogapeInfoClient } from '../interface/fogape-client.interface';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { ClientCreditNoteDTO } from '../interface/credit-notes.interface';
import { DateFiltersFilesClients, DateFiltersFilesClientsApproved } from '../interface/filters-files-clients.interface';
import { ClientCompanyToDebtorRelationSummaryDTO } from '../interface/company-to-debtor.interface';
import { CompanyDraftInvoiceOperationDTO, FactoringInvoices } from '../interface/invoice-operation.interface';
import { ClientCesionarioDTO } from '../interface/client-cesionario.interface';
import { CompanyRelationNodeDTO } from '../interface/company-corporate-mesh.interface';
import { ActionDeals, Deal, PageResultDeals, RequestActions, TagsRequestResponse } from '../../clients/interface/data.interface';
import { PageResultDealsEvaluation, RequestDeals } from '../../warranties/interfaces/deals';

@Injectable({
  providedIn: 'root',
})
export class ServiceInfoClientService {
  constructor(private http: HttpClient) {}

  summaryCompany(request: number, filter: DateFiltersFilesClients): Observable<any> {
    let params = new HttpParams()
    .set('start', filter.start)
    .set('end', filter.end)
    .set('search', filter.search || '');
    const endpoint = `${environment.apiUrl}/Company/${request}/summary`;
    return this.http.get<SummaryCompany>(endpoint, {params: params});
  }

  monthlySummaryCompany(request: number, filter: DateFiltersFilesClients): Observable<any> {
    let params = new HttpParams()
    .set('start', filter.start)
    .set('end', filter.end)
    .set('search', filter.search || '');
    const endpoint = `${environment.apiUrl}/Company/${request}/monthlyActivity`;
    return this.http.get<MonthlyActivity[]>(endpoint, {params: params});
  }

  infoCompany(request: number): Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/${request}/info`;
    return this.http.get<InfoCompany>(endpoint);
  }

  //SOCIOS
  getOwners(request: number) {
    const endpoint = `${environment.apiUrl}/Company/${request}/owners`;
    return this.http.get<Owners[]>(endpoint);
  }

  getCompanyRelations(request: number){
    const endpoint = `${environment.apiUrl}/Company/${request}/RelationedCompaniesOrPartners`;
    return this.http.get<CompanyRelations>(endpoint);
  }

  createOwner(request: InfoOwners) {
    const endpoint = `${environment.apiUrl}/Company/companyRelation?syncAdmin=true`;
    return this.http.post<any>(endpoint, request);
  }

  updateOwners(request: any) {
    const { companyLegalOwnerId } = request;
    const endpoint = `${environment.apiUrl}/Company/UpdateOwner/${companyLegalOwnerId}?syncAdmin=true`;
    return this.http.post<any>(endpoint, request);
  }

  deleteOwner(request: number) {
    const endpoint = `${environment.apiUrl}/Company/companyRelation/${request}`;
    return this.http.delete<string>(endpoint);
  }

  //Deudores
  /**
   * Metodo para solicitar a API consultar todos los deudores de un cliente
   * @param request 
   * @returns 
   */
  debtorsCompany(request: RequestDeptors) {
    const { id, start, end, top, search } = request;
    let queryParams = new HttpParams()
    .set('start', start)
    .set('end', end)
    .set ('search', search ||'')
    .set('top', top || '');
    const endpoint = `${environment.apiUrl}/Company/${id}/debtors`;
    return this.http.get<Deptors[]>(endpoint, {params: queryParams});
  }

  debtorsFiltersCompany(request: RequestDeptors) {
    const { id, top } = request;
    const endpoint = `${environment.apiUrl}/Company/${id}/debtors?top=${top}`;
    return this.http.get<Deptors[]>(endpoint);
  }

  debtorsFilterSearch(request: RequestDeptors) {
    const { id, search } = request;
    const endpoint = `${environment.apiUrl}/Company/${id}/debtors?search=${search}`;
    return this.http.get<Deptors[]>(endpoint);
  }

  //Facturas
  invoices(companyId:number, filters: DateFiltersFilesClients, pagination: FilterPagination): Observable<any> {
    const { page, pageSize, sortOrder } = pagination;
    const {start, end, search} = filters
    let queryParams = new HttpParams()
    .set('pageSize', pageSize)
    .set('page', page)
    .set('search', search)
    .set('start', start)
    .set('end', end)
    .set('sortOrder', sortOrder || '');
    const endpoint = `${environment.apiUrl}/Company/${companyId}/invoices`;
    return this.http.get<RequestInvoices>(endpoint, { params: queryParams});
  }

  topInvoices(companyId:number, filters: DateFiltersFilesClients, pagination: FilterPagination): Observable<any> {
    const { page, pageSize, sortOrder } = pagination;
    const {start, end, search} = filters
    let queryParams = new HttpParams()
    .set('pageSize', pageSize)
    .set('page', page)
    .set('search', search)
    .set('start', start)
    .set('end', end)
    .set('sortOrder', sortOrder || '');
    const endpoint = `${environment.apiUrl}/Company/${companyId}/topInvoices`;
    return this.http.get<ResultsTopInvoices>(endpoint, { params: queryParams});
  }

  //Filtro Facturas por tamaño de pagina
  invoicesPaginator(request: FilterPagination): Observable<any> {
    const { companyId, page, pageSize } = request;
    const endpoint = `${environment.apiUrl}/Company/${companyId}/invoices?pageSize=${pageSize}&page=${page} `;
    return this.http.get<RequestInvoices>(endpoint);
  }

  invoicesSearch(request: FilterPagination): Observable<any> {
    const { companyId, search } = request;
    const endpoint = `${environment.apiUrl}/Company/${companyId}/invoices?search=${search}`;
    return this.http.get<RequestInvoices>(endpoint);
  }

  public getSellFactoringInvoice(request:number): Observable<FactoringInvoices[]> {
    const endpoint = `${environment.apiUrl}/invoice/factoringSellInvoices/${request}`;
    return this.http.get<FactoringInvoices[]>(endpoint);
  }

  //Minutas
  minutes(request: number): Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/${request}/minutes`;
    return this.http.get<RequestMinutes>(endpoint);
  }
  //Operaciones
  getOperations(companyId: number, filter: DateFiltersFilesClients): Observable<any> {
    let queryParams = new HttpParams()
    .set('start', filter.start)
    .set('end', filter.end)
    .set('search', filter.search || '')
    const endpoint = `${environment.apiUrl}/Company/${companyId}/operations`;
    return this.http.get<Operations>(endpoint, {params: queryParams});
  }
  getOperationsApproved(companyId: number, filter: DateFiltersFilesClientsApproved): Observable<any> {
    let queryParams = new HttpParams()
    .set('start', filter.start)
    .set('end', filter.end)
    .set('search', filter.search || '')
    .set('idState', filter.idState)
    const endpoint = `${environment.apiUrl}/Company/${companyId}/operations`;
    return this.http.get<Operations>(endpoint, {params: queryParams});
  }

  getDetailOperations(operationId: bigint): Observable<any> {
    const endpoint = `${environment.apiUrl}/FactoringOperation/${operationId}`;
    return this.http.get<DetailOperations>(endpoint);
  }


  getOperationsSearch(request: RequestDeptors): Observable<any> {
    const { id, search } = request;
    const endpoint = `${environment.apiUrl}/Company/${id}/operations?search=${search}`;
    return this.http.get<Operations>(endpoint);
  }

  getOperationsDate(request: any): Observable<any> {
    const { companyId, start, end } = request;
    const endpoint = `${environment.apiUrl}/Company/${companyId}/operations?start=${start}&end=${end}`;
    return this.http.get<Operations>(endpoint);
  }

  getFogapeInfo(companyId: number) {
    const endpoint = `${environment.apiUrl}/Company/${companyId}/fogape`;
    return this.http.get<FogapeInfoClient>(endpoint);
  }

  updateInfo(companyId, request) {
    const endpoint = `${environment.apiUrl}/Company/UpdateInfo/${companyId}?refreshAdmin=true`;
    return this.http.put<any>(endpoint, request);
  }

  getInfoSiiCompany(companyId) {
    const endpoint = `${environment.apiUrl}/Company/SII/${companyId}`;
    return this.http.get<CompanyInfoSii>(endpoint);
  }

  getCompanyCreditNotes(companyId:number, filter: DateFiltersFilesClients, pagination: FilterPagination) {
    const {start, end, search} = filter
    const { page, pageSize, sortOrder } = pagination
    let queryParams = new HttpParams()
      .set('start', start)
      .set('end', end)
      .set('page', page)
      .set('size', pageSize)
      .set('sortOrder', sortOrder || '')
      .set('search', search);
    const endpoint = `${environment.apiUrl}/Company/${companyId}/CreditNotes`;
    return this.http.get<PageResult<ClientCreditNoteDTO>>(endpoint, {params: queryParams});
  }

  getCompanyBuyInvoicesFactoring(companyId: number, filter: DateFiltersFilesClients, pagination: FilterPagination): Observable<PageResult<FactoringInvoices>> {
    const { start, end, search} = filter;
    const {page, pageSize, sortOrder} = pagination;
    let queryParams = new HttpParams()
    .set('start', start)
    .set('end', end)
    .set('page', page)
    .set('size', pageSize)
    .set('sortOrder', sortOrder || '')
    .set('search', search);
    const endpoint = `${environment.apiUrl}/invoice/factoringSellInvoices/${companyId}`;
    return this.http.get<PageResult<FactoringInvoices>>(endpoint, {params: queryParams});
  }

  getCompanyCesionarios(companyId: number, filter:DateFiltersFilesClients, pagination: FilterPagination) : Observable<PageResult<ClientCesionarioDTO>>{
    const { start, end, search} = filter;
    const {page, pageSize, sortOrder} = pagination;
    let queryParams = new HttpParams()
    .set('start', start)
    .set('end', end)
    .set('page', page)
    .set('size', pageSize)
    .set('sortOrder', sortOrder || '')
    .set('search', search);
    const endpoint = `${environment.apiUrl}/Company/${companyId}/cesionarios`;
    return this.http.get<PageResult<ClientCesionarioDTO>>(endpoint, {params: queryParams});
  }

  getCompanyBuyInvoices(companyId: number, filter: DateFiltersFilesClients, pagination: FilterPagination): Observable<PageResult<ResultsInvoice>> {
    const { start, end, search} = filter;
    const {page, pageSize, sortOrder} = pagination;
    let queryParams = new HttpParams()
    .set('start', start)
    .set('end', end)
    .set('page', page)
    .set('size', pageSize)
    .set('sortOrder', sortOrder || '')
    .set('search', search);
    const endpoint = `${environment.apiUrl}/Company/${companyId}/buyInvoices`;
    return this.http.get<PageResult<ResultsInvoice>>(endpoint, {params: queryParams});
  }

  getCompanyTopBuyInvoices(companyId: number, filter: DateFiltersFilesClients, pagination: FilterPagination): Observable<PageResult<ResultsTopInvoices>> {
    const { start, end, search} = filter;
    const {page, pageSize, sortOrder} = pagination;
    let queryParams = new HttpParams()
    .set('start', start)
    .set('end', end)
    .set('page', page)
    .set('size', pageSize)
    .set('sortOrder', sortOrder || '')
    .set('search', search);
    const endpoint = `${environment.apiUrl}/Company/${companyId}/buyTopInvoices`;
    return this.http.get<PageResult<ResultsTopInvoices>>(endpoint, {params: queryParams});
  }

  getCompanyWarranties(companyId: number, search: string):Observable<ClientWarranty[]> {
    let params = new HttpParams()
    .set('search', search || '');
    const endpoint = `${environment.apiUrl}/Company/${companyId}/warranties`;
    return this.http.get<ClientWarranty[]>(endpoint, { params: params});
  }

  postApprovedWarranties(emailUser:string, warrantyId:number, isBuilding:boolean):Observable<any>{
    const request = {
      warrantyId: warrantyId,
      isBuilding: isBuilding,
      emailUser: emailUser
    };
    const endpoint = `${environment.apiUrl}/Company/${warrantyId}/warrantiesApprove?emailUser=${emailUser}&isBuilding=${isBuilding}`;
    return this.http.post<ClientWarranty[]>(endpoint, request);
  }

  postRejectWarranties( warrantyId:number):Observable<any>{
     const endpoint = `${environment.apiUrl}/Company/${warrantyId}/rejectWarranties`;
     return this.http.post<ClientWarranty[]>(endpoint, warrantyId);
   }

  getCompanyPendingApproveWarranties(companyId: number, search: string): Observable<ClientWarranty[]> {
    let params = new HttpParams()
    .set('search', search || '');
    const endpoint = `${environment.apiUrl}/Company/${companyId}/warranties/pendingApprove`;
    return this.http.get<ClientWarranty[]>(endpoint, {params: params});
  }

  getAwaitingPaymentWarranties(companyId: number): Observable<ClientWarranty[]> {
    const endpoint = `${environment.apiUrl}/Company/${companyId}/warranties/awaitingPayment`;
    return this.http.get<ClientWarranty[]>(endpoint);
  }

  getDebtCompanies(companyId:number){
    const endpoint = `${environment.apiUrl}/Company/${companyId}/InfoDeudasCliente`;
    return this.http.get<DebtsCompaniesAll>(endpoint);
  }

  getMyAssignmentInCompany(companyId: number): Observable<CompanyUserAssignment | null>{
    const endpoint = `${environment.apiUrl}/Company/${companyId}/myAssignment`;
    return this.http.get<CompanyUserAssignment | null>(endpoint)
    .pipe(
     catchError(err => {
      return throwError(() => null)
     })
    )
  }

  getCompanyMercadoPublicoInfo(companyId: number): Observable<CompanyMPSummary> {
    const endpoint = `${environment.apiUrl}/Company/${companyId}/InfoMercadoPublico`;
    return this.http.get<CompanyMPSummary>(endpoint);
  }

  getCompanyToDebtorRelationship(clientCompanyId:number, debtorCompanyId: number, start:Date | null, end: Date | null): Observable<ClientCompanyToDebtorRelationSummaryDTO> {
    let params = new HttpParams()
    .set('start', start?.toISOString() || '')
    .set('end', end?.toISOString() || '');
    const endpoint = `${environment.apiUrl}/Company/${clientCompanyId}/debtor/${debtorCompanyId}/relation`;
    return this.http.get<ClientCompanyToDebtorRelationSummaryDTO>(endpoint, {params: params});
  }

  updateInvocesCompany(meses: number, companyId: number): Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/${companyId}/GetCompanyInvoiceUpdate/`;
    return this.http.post<any>(endpoint, meses);
  }

  addClientDebtor(request): Observable<any>{
    const endpoint = `${environment.apiUrl}/Company/AddClientAndDebt`;
    return this.http.put<any>(endpoint,request )
  }

  getDraftInvoiceOperationCompany(companyId: number): Observable<CompanyDraftInvoiceOperationDTO[]> {
    const endpoint = `${environment.apiUrl}/Company/${companyId}/operations/draft`;
    return this.http.get<CompanyDraftInvoiceOperationDTO[]>(endpoint);
  }

  getCompanyRelationshipMesh(companyId: number): Observable<Array<CompanyRelationNodeDTO>> {
    const endpoint = `${environment.apiUrl}/Company/${companyId}/relationship/children`;
    return this.http.get<Array<CompanyRelationNodeDTO>>(endpoint);
  }

  getDealsCompany(companyId: string, pagination: FilterPagination): Observable<PageResultDeals> {
    const {page, pageSize, sortOrder, sortColumn} = pagination;
    let queryParams = new HttpParams()
    .set('page', page)
    .set('pageSize', pageSize)
    .set('sortOrder', sortOrder || '')
    .set('sortColumn', sortColumn || '')
    const endpoint = `${environment.apiUrl}/Company/${companyId}/deals`;
    return this.http.get<PageResultDeals>(endpoint, {params: queryParams});
  }

  getDealsEvaluation(request: RequestDeals): Observable<PageResultDealsEvaluation> {
    const {page, pageSize, sortField, sortDirection, search, finalidad, start, end, estado, estadoActiviti, estadoAccion, etiqueta} = request;
    let queryParams = new HttpParams()
    .set('page', page)
    .set('pageSize', pageSize)
    .set('sortField', sortField || '')
    .set('sortDirection', sortDirection || '')
    .set('search', search || '')
    .set('finalidad', finalidad || '')
    .set('start', start?.toISOString() || '')
    .set('end', end?.toISOString() || '')
    .set('position', estado || '')
    .set('state', estadoActiviti || '')
    .set('accion', estadoAccion || '')
    .set('etiqueta', etiqueta || '')
    const endpoint = `${environment.apiUrl}/Company/dealsEvaluations`;
    return this.http.get<PageResultDealsEvaluation>(endpoint, {params: queryParams});
  }

  putDealAprove(request: RequestActions): Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/deals/approve`;
    return this.http.put<any>(endpoint,request )
  }

  putDealReject(request: RequestActions): Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/deals/reject`;
    return this.http.put<any>(endpoint,request )
  }

  putDealPending(request: RequestActions): Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/deals/pending`;
    return this.http.put<any>(endpoint,request )
  }

  getDealsTags() : Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/tagsDeals`;
    return this.http.get<any>(endpoint);
  }

  putDealTags(request: TagsRequestResponse) : Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/tagsDeals`;
    return this.http.put<any>(endpoint, request);
  }

  getDealsActions() : Observable<any> {
    const endpoint = `${environment.apiUrl}/Company/actionDeals`;
    return this.http.get<any>(endpoint);
  }

}